import React from 'react';
import { ProductPayment } from '../types/transactionTypes';
import { formatCurrency } from '@/lib';

interface LegacyFeeBreakdownTooltipProps {
    paymentData: ProductPayment;
    paymentMethodType: string;
}

export const LegacyFeeBreakdownTooltip: React.FC<LegacyFeeBreakdownTooltipProps> = ({
    paymentData,
    paymentMethodType,
}) => {
    const feeBreakdown = paymentData?.application_fee_breakdown;

    return (
        <div className='flex flex-col items-start p-1 text-left text-sm'>
            <div className='text-xs font-bold'>{paymentMethodType} Fee Breakdown</div>

            {feeBreakdown?.payout_fee && (
                <div className='mt-2'>
                    Stripe&apos;s Payout Fee:{' '}
                    <span className='font-semibold'>
                        {formatCurrency(feeBreakdown.payout_fee ?? 0, paymentData.currency_base ?? 'USD')}
                    </span>
                </div>
            )}

            {feeBreakdown?.connect_account_fee && (
                <div className='mt-2'>
                    Stripe&apos;s Account Fee:{' '}
                    <span className='font-semibold'>
                        {formatCurrency(feeBreakdown.connect_account_fee ?? 0, paymentData.currency ?? 'USD')}
                    </span>
                </div>
            )}

            <div className='text-gray mt-2 text-xs'>
                Learn more about Stripe&apos;s fees{' '}
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    className='underline'
                    href='https://help.stan.store/article/83-stan-stripes-transaction-fees'
                >
                    here
                </a>
                .
            </div>
        </div>
    );
};
